export function getCookieName() {
    if (process.env.REACT_APP_ENV === "production") {
        return "tastea-cookie-consent-production";
    }
    return "tastea-cookie-consent";
}